module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom6.9f1938c4.jpg";